import { Pie } from "@ant-design/plots"
import { Skeleton } from "components/common"

const DonutChart = ({
  loading,
  disabled,
  angleField = "value",
  colorField = "type",
  radius = 0.8,
  innerRadius = 0.7,
  ...config
}) => {
  return loading ? (
    <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
      <div style={{ position: "relative", width: 260, height: 260 }}>
        <Skeleton type="avatar" size={260} avatarShape="circle" active />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 130,
            height: 130,
            borderRadius: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </div>
  ) : (
    <Pie
      angleField={angleField}
      colorField={colorField}
      radius={radius}
      innerRadius={innerRadius}
      label={false}
      legend={{ position: "bottom", flipPage: false, offsetY: 6, }}
      style={disabled ? { pointerEvents: "none", opacity: 0.7 } : undefined}
      {...config}
    />
  )
}
export default DonutChart
